// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.amend-share-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.amend-shares-options {
  margin-top: 2rem;
  margin-bottom: 2.5rem;
  width: 35rem;
}
.amend-shares-options button {
  width: 100%;
}
.amend-shares-options .top-section p {
  margin-top: 1.5rem;
}
.amend-shares-options .buttons-area {
  margin-top: 2rem;
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
}
.amend-shares-options .buttons-area .button-component {
  width: 100%;
}
.amend-shares-options .buttons-area .button-component button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/OverclaimView/DisputeOptionSection/AmendSharesOptions/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,gBAAA;EACA,qBAAA;EACA,YAAA;AACF;AACE;EACE,WAAA;AACJ;AAGI;EACE,kBAAA;AADN;AAKE;EACE,gBAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;AAHJ;AAKI;EACE,WAAA;AAHN;AAKM;EACE,WAAA;AAHR","sourcesContent":[".amend-share-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.amend-shares-options {\n  margin-top: 2rem;\n  margin-bottom: 2.5rem;\n  width: 35rem;\n\n  button {\n    width: 100%;\n  }\n\n  .top-section {\n    p {\n      margin-top: 1.5rem;\n    }\n  }\n\n  .buttons-area {\n    margin-top: 2rem;\n    display: flex;\n    justify-content: space-between;\n    gap: 1.5rem;\n\n    .button-component {\n      width: 100%;\n\n      button {\n        width: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
